// removed by extract-text-webpack-plugin
module.exports = {"container":"Header__container___2VcPM","details":"Header__details___283Sa","button-container":"Header__button-container___3lAEx","controls":"Header__controls___d6URw"};